import { QuotationCatalog } from '@euler/app/flows/task/pages/quotation/types/QuotationCatalog';
import { useNavigation } from '@react-navigation/native';
import { ReactNode, createContext, memo, useCallback, useContext } from 'react';

export type QuotationContextProps = {
  catalog: QuotationCatalog;
  finish: () => void;
};

export const QuotationContext = createContext<QuotationContextProps>(
  null as any,
);

export const useQuotationContext = () => useContext(QuotationContext);

export const QuotationProvider = memo(
  ({
    catalog,
    children,
  }: {
    catalog: QuotationCatalog;
    children?: ReactNode;
  }) => {
    const navigation = useNavigation();

    const finish = useCallback(() => {
      navigation.goBack();
    }, [navigation]);

    return (
      <QuotationContext.Provider
        value={{
          catalog,
          finish,
        }}
      >
        {children}
      </QuotationContext.Provider>
    );
  },
);
